export default __webpack_public_path__ + "images/wiring-roof.1c6ba8de4b09f30fa747756a5c8fec26.png";